import React from "react"
import PropTypes from "prop-types"
import ScrollToPosition from '../utils/ScrollToPosition';
import lottie from 'lottie-web';

class AlertModal extends React.Component {
  constructor(props) {
    super(props)

    this.color = this.color.bind(this)
  }

  color() {
    if(this.props.alert) {
      return '#E57373'
    }
    return '#03A9F4'
  }

  render() {
    return(
      <div
        onClick={() => this.props.onClose()}
        style={{top: 0, left: 0, position: 'absolute', width: '100%', height: '100%', display: 'flex', justifyContent: 'center', zIndex: 11, backgroundColor: 'rgba(255,255,255,.5)'}}>
        <ScrollToPosition />
        <div className="standardModal" style={{padding: 0, textAlign: 'center'}}>
          <div style={{backgroundColor: this.color(), padding: 15, borderTopLeftRadius: 8, borderTopRightRadius: 8}}>
            <h3 className="white">{this.props.bannerText}</h3>
          </div>
          <h3 className="sectionHeader" style={{marginTop: 15, marginBottom: 15}}>{this.props.headerText}</h3>
          {this.props.subHeaderText && <h4 style={{color: '#A3A3A4'}}>{this.props.subHeaderText}</h4>}

          <div style={{padding: 15, justifyContent: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
            <h4 className="sectionText" style={{marginBottom: 30, marginTop: 30, textAlign: 'left'}}>{this.props.mainText}</h4>
            <button className="button_primary" style={{backgroundColor: this.color()}} onClick={() => this.props.onClick()}>{this.props.buttonText}</button>
          </div>

        </div >
      </div>
    )
  }
}

export default AlertModal;
